import { createReducer, on } from '@ngrx/store';
import { setchangeDateInitVigEndosoAction } from './changeDateInitVigEndoso.actions';

export const initialState = false;

export const changeDateInitVigEndosoReducer = createReducer(
  initialState,
  on(setchangeDateInitVigEndosoAction, (state, { changeDateInitVigEndoso}) => changeDateInitVigEndoso)
);
